import { createSearchService } from "../application/services/SearchService";
import { searchAdapter } from "../infra/adapters/search.adapter";
import { baseBuild } from "@/core/services/network/config/baseBuild";
import type { AppDispatch } from "@/app/store/store";

/**
 * Factory function to wire infrastructure -> application layer
 * This is where dependency injection happens
 * 
 * Uses RTK Query adapter for automatic caching and request deduplication
 */
export function searchBuild(dispatch: AppDispatch) {
  return baseBuild(
    (dispatch) => new searchAdapter(dispatch),
    (repo) => createSearchService(repo),
    dispatch
  );
}

